import { map } from "rxjs/operators";
import { of as observableOf, Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { SyncService } from "./sync.service";

////////////////////////////////////////////////////////////////////////////
export class GeocoderViewModel {
  Name: string = "";
  Provider: string = "";
  Key: string = "";
  Url: string = "";

  init(data?: any) {
    if (data) {
      this.Name = data["name"];
      this.Provider = data["provider"];
      this.Key = data["key"];
      this.Url = data["url"];
    }
  }

  static fromJS(data: any): GeocoderViewModel {
    const result = new GeocoderViewModel();
    if (typeof (data) === 'object')
      result.init(data);
    return result;
  }
}
////////////////////////////////////////////////////////////////////////////
export class MapLayerViewModel {
  Name: string = "";
  Provider: string = "";
  URL: string = "";
  Layers: string = "";
  Key: string = "";
  IsBased: boolean = true;

  init(data?: any) {
    if (data) {
      this.Name = data["name"];
      this.Provider = data["provider"];
      this.Key = data["key"];
      this.URL = data["url"];
      this.Layers = data["layers"];
      this.IsBased = data["isBased"];
    }
  }

  static fromJS(data: any): MapLayerViewModel {
    const result = new MapLayerViewModel();
    if (typeof (data) === 'object')
      result.init(data);
    return result;
  }
}
////////////////////////////////////////////////////////////////////////////
export class DomainViewModel {
  Id = 0;
  Name: string = "";
  Title: string = "";
  Key: string = "";
  LogoLink: string = "";
  AppleStoreLink: string = "";
  PlayMarketLink: string = "";
  OuterLogo64: string = "";
  InnerLogo64: string = "";
  FavIcon64: string = "";

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.Title = data["title"];
      this.Key = data["key"];
      this.LogoLink = data["logoLink"];
      this.PlayMarketLink = data["playMarketLink"];
      this.AppleStoreLink = data["appleStoreLink"];
      this.OuterLogo64 = data["outerLogo64"] ?? "";
      this.InnerLogo64 = data["innerLogo64"] ?? "";
      this.FavIcon64 = data["favIcon64"] ?? "";
    }
  }

  static fromJS(data: any): DomainViewModel {
    const result = new DomainViewModel();
    if (typeof (data) === 'object')
      result.init(data);
    return result;
  }
}
////////////////////////////////////////////////////////////////////////////
export class ServerSettingsViewModel {
  domains: Array<DomainViewModel> = [];
  maplayers: Array<MapLayerViewModel> = [];
  geocoders: Array<GeocoderViewModel> = [];

  init(data?: any) {
    if (data) {
      for (let item of data["mapLayers"])
        this.maplayers.push(MapLayerViewModel.fromJS(item));

      for (let item of data["domains"])
        this.domains.push(DomainViewModel.fromJS(item));

      for (let item of data["geocoders"])
        this.geocoders.push(GeocoderViewModel.fromJS(item));
    }
  }

  static fromJS(data: any): ServerSettingsViewModel {
    const result = new ServerSettingsViewModel();
    if (typeof (data) === 'object')
      result.init(data);
    return result;
  }
}
////////////////////////////////////////////////////////////////////////////
export class TimezoneViewModel {
  Name: string = "";
  DisplayName: string = "";
  Offset: number = 0;

  init(data?: any) {
    if (data) {
      this.Name = data["name"];
      this.Offset = data["offset"];
      this.DisplayName = data["displayName"];
    }
  }

  static fromJS(data: any): TimezoneViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new TimezoneViewModel();
    result.init(data);
    return result;
  }
}
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
@Injectable()
export class SettingsService {
  private client = inject(HttpClient);

  constructor(private syncService: SyncService) {
  }
  private _gecodersRequest = this.client.get<string[]>("/ctrl/settings/geocoders").pipe(map(values => {
    let result = [];
    for (let item of values)
      result.push(GeocoderViewModel.fromJS(item))
    return result;
  }));

  private _timezonesRequest = this.client.get<string[]>("/ctrl/settings/timezones").pipe(map(values => {
    let result = [];
    for (let item of values)
      result.push(TimezoneViewModel.fromJS(item))
    return result;
  }));
  private timezones: TimezoneViewModel[] = [];
  private geocoders: GeocoderViewModel[] = [];



  public getTimezones(): Observable<TimezoneViewModel[]> {
    if (this.timezones.length == 0)
      return this._timezonesRequest.pipe(map(tz => {
        this.timezones = tz;
        return tz;
      }));
    return observableOf(this.timezones);
  }

  public getGeocoders(): Observable<GeocoderViewModel[]> {
    if (this.geocoders.length == 0)
      return this._gecodersRequest.pipe(map(gc => {
        this.geocoders = gc;
        return gc;
      }));
    return observableOf(this.geocoders);
  }

  public getServerSettings(): Observable<ServerSettingsViewModel> {
    return this.client.get<any>("/ctrl/settings").pipe(map(values => {
      return ServerSettingsViewModel.fromJS(values);
    }));
  }
  public setServerSettings(model: ServerSettingsViewModel) {
    return this.client.put("/ctrl/settings", model).pipe(map(res => {
      this.syncService.NotifyEntityChanged("Profile", 0);
      return res;
    }));
  }
}
